import React, { useState } from 'react';
import { FormInstance } from 'types/step';
import * as ChatBubbleStyled from 'eCoach/_styles/ChatBubble.style';
import * as Text from 'theme/components/Text.style';
import { Form, Formik } from 'formik';
import { useFormInstanceMutation } from 'shared/hooks/api/formFilling';
import * as Styled from 'eCoach/_styles/FormBuilder.style';
import { General } from 'icons/untitledui';
import { useTranslation } from 'react-i18next';
import getFormDefinition, {
  getFilledData,
  getInitialValues,
} from 'form/helpers/formFillingUtils';
import ChatBubble from '../ChatBubble';
import FormInput from './FormInput';

interface FormBuilderProps {
  formInstance: FormInstance;
}

export default function FormBuilder({ formInstance }: FormBuilderProps) {
  const { t } = useTranslation('pageEcoach');
  const [file, setFile] = useState<string | null>(formInstance.file || null);
  const [formOpen, setFormOpen] = useState(!file);
  const { mutate: updateFormInstance, isPending } = useFormInstanceMutation(
    formInstance.id,
    {
      onSuccess: (data: FormInstance) => {
        setFile(data.file);
        setFormOpen(!data.file);
      },
    }
  );

  const formDefinition = getFormDefinition(
    formInstance.form_template.placeholders
  );
  const initialValues = getInitialValues(
    formDefinition,
    formInstance.filled_data
  );

  const handleSubmit = (values: any, { setSubmitting }) => {
    const filledData = getFilledData(formDefinition, values);
    updateFormInstance({
      filled_data: filledData,
    });
    setSubmitting(false);
  };

  return (
    <ChatBubble sentByUser>
      <ChatBubbleStyled.UserMessage>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ dirty, submitForm }) => (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (!dirty && file) {
                  setFormOpen(false);
                  return;
                }
                submitForm();
              }}
            >
              <ChatBubbleStyled.DescriptionText>
                <Text.H5 style={{ minWidth: '400px' }}>
                  {formInstance.form_template.document_translation.title}
                </Text.H5>
                <Styled.FormContainer>
                  {formDefinition.map(
                    ({ slug, displayName, type, options, format }) => (
                      <FormInput
                        key={slug}
                        fieldKey={slug}
                        label={displayName}
                        inputType={type}
                        options={options}
                        format={format}
                        readonly={!formOpen}
                      />
                    )
                  )}
                </Styled.FormContainer>
                {formOpen ? (
                  <Styled.MediumPrimaryButton
                    stretch
                    type="submit"
                    disabled={isPending}
                  >
                    {t('Save')}
                  </Styled.MediumPrimaryButton>
                ) : (
                  <Styled.FormButtonsContainer>
                    <Styled.DownloadButton
                      as="a"
                      disabled={isPending}
                      href={isPending ? undefined : file}
                    >
                      <General.Download01 />
                      {t('Download')}
                    </Styled.DownloadButton>
                    <Styled.FormButton onClick={() => setFormOpen(true)}>
                      <General.Edit05 />
                    </Styled.FormButton>
                  </Styled.FormButtonsContainer>
                )}
              </ChatBubbleStyled.DescriptionText>
            </Form>
          )}
        </Formik>
      </ChatBubbleStyled.UserMessage>
    </ChatBubble>
  );
}
